import { Observable, OperatorFunction } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ActionCreator, AnyAction } from 'typescript-fsa';

export function isTypeOfAndGetPayload<R>(
  actionFactory: ActionCreator<R>,
): OperatorFunction<AnyAction, R> {
  function isTypeOfAndGetPayloadOperation(source: Observable<AnyAction>) {
    return source.pipe(
      filter(actionFactory.match),
      map((action) => action.payload),
    );
  }

  return isTypeOfAndGetPayloadOperation;
}
